function PainPointList({ painPoints, onChange }) {
	return painPoints.map((pp, i) => {
		return <div key={i}></div>;
	});
}

export default PainPointList;
